﻿import OverviewMap from 'ol/control/OverviewMap';
import * as eventTypes from '../../../map/utils/eventTypes';
export default class OverviewControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.control = null;
    }

    init() {
        if (this._isMobileDevice()) return;

        if (this.mapControl.map.getAllLayers().length > 0) {
            let existingLayers = this.mapControl.map.getAllLayers();
            let layers = [];

            existingLayers.forEach(layer => {
                let clone = this._cloneForOverview(layer);
                clone.set('uid', layer.get('uid'));
                layers.push(clone);
            });

            this.control = new OverviewMap({
                layers: layers,
                collapsed: false
            });

            this.mapControl.map.addControl(this.control);

            $('.ol-overviewmap').removeClass('ol-collapsed');
        } else {
            setTimeout(() => {
                this.init();
            }, 100);
        }

        $event.register(eventTypes.LAYER_VISIBILITY_CHANGED, this._getLayerVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ORDER_CHANGED, this._getLayersChangedHandler(), this, this.classId);
        $event.register(eventTypes.LEGEND_LAYER_RECREATED, this._getLayersChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ADDED, this._getLayersChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_STYLE_CHANGED, this._getLayersChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_OPACITY_CHANGED, this._getLayerOpacityChangedHandler(), this, this.classId);
    }

    _getLayersChangedHandler() {
        var handler = (eventName, data, sender) => {
            setTimeout(() => {
                this.control.getOverviewMap().getLayers().clear();

                let existingLayers = this.mapControl.map.getAllLayers();

                existingLayers.forEach(layer => {
                    let clone = this._cloneForOverview(layer);
                    clone.set('uid', layer.get('uid'));
                    this.control.getOverviewMap().getLayers().push(clone);
                });
            }, 200);
        };

        return handler;
    }

    _getLayerVisibilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._getLayerById(data.layerId);

                if (layer.length > 0) {
                    layer[0].setVisible(data.visible);
                }
            }
        };

        return handler;
    }

    _getLayerOpacityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._getLayerById(data.layerId);

                if (layer.length > 0) {
                    layer[0].setOpacity(data.opacity);
                }
            }
        };

        return handler;
    }

    _getLayerById(id) {
        let result = [];
        let layers = this.control.getOverviewMap().getAllLayers();
        for (var i = 0; i < layers.length; i++) {
            if (layers[i].get("uid") == id) {
                result.push(layers[i]);
            }
        }

        return result;
    }

    _cloneForOverview(layer, { reuseSource = true } = {}) {
        const Ctor = layer.constructor;
        const source = reuseSource
            ? layer.getSource()
            : layer.getSource()?.clone?.() ?? layer.getSource();

        const opts = {
            source,
            visible: layer.getVisible(),
            opacity: layer.getOpacity(),
            extent: layer.getExtent(),
            zIndex: layer.getZIndex(),
            minResolution: layer.getMinResolution(),
            maxResolution: layer.getMaxResolution()
        };

        if (layer.getStyle) {
            opts.style = layer.getStyle();
        }

        return new Ctor(opts);
    }

    _isMobileDevice() {
        let supportsTouch = ('ontouchstart' in window || navigator.msMaxTouchPoints) && (window.innerWidth < 750);
        return supportsTouch;
    }
}